import React from 'react';
import CommonErrorPage from '../Common/CommonErrorPage';
import { Error1 } from '../../Common/CommonPageIcon';

export default function ErrorPage1() {
   return (
      <CommonErrorPage title="Página no encontrada" errorIcon={<Error1 />} />
   );
}
